import { makeObservable, observable, transaction } from "mobx"
import { getSupportedGames, patchSupportedGame } from "domains/gameplay-boost-games/api/gameplay-boost-games.call"
import { BaseStore } from "stores/base.store"
import { RootStore } from "stores/root.store"
import { SupportedGame } from "./types"

export class GameplayBoostGamesStore extends BaseStore {
  @observable
  public isLoading: boolean = false

  @observable
  public games: SupportedGame[] = []

  constructor(rootStore: RootStore) {
    super(rootStore)
    makeObservable(this)
  }

  public async loadGames(): Promise<void> {
    const res = await this.defaultFunction(getSupportedGames)
    transaction(() => {
      this.games = Array.isArray(res) ? res : []
    })
  }

  public async setPicture(gameId: number, pictureUrl: string | null): Promise<boolean> {
    const res = await this.defaultFunction(patchSupportedGame, gameId, { pictureUrl })
    if (res?.gameId !== gameId) return false
    transaction(() => {
      this.games = this.games.map(game => (game.gameId === gameId ? res : game))
    })

    return true
  }
}
